<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 632 542">
  <path
    fill="#fec24c"
    d="M282.268 38.445 159.545 171.956 36.821 38.445 0 75.266l133.511 122.723L0 320.713l36.821 36.821 122.724-133.511 122.723 133.511 36.821-36.821-133.51-122.724 133.51-122.723-36.821-36.821Z"
  />
  <path
    fill="#1767a3"
    d="m159.544 171.954 50.636-55.079c-14.11-10.709-31.675-17.052-50.636-17.052-18.961 0-36.526 6.344-50.636 17.052l50.636 55.079Zm88.042 83.034-4.374-77.26c-.677-9.468-2.985-18.432-6.508-26.737l-51.131 47 62.013 56.997Zm-88.042-30.966L67.592 324.061l-12.34 217.791 208.401-.087-12.158-217.704-91.951-100.039Zm-26.034-26.034-51.122-46.991c-3.523 8.305-5.832 17.26-6.508 26.728l-4.382 77.26 62.012-56.997Z"
  />
  <path
    fill="#368cd6"
    d="m245.601 220.074 1.979 34.92-18.649-17.139 90.147 82.866-36.812 36.812-53.335-58.013 22.563 24.542 12.149 217.713 367.66-.004V342.177L245.601 220.074Zm-56.494 321.693h-52.068v-78.102c0-14.379 11.655-26.034 26.034-26.034s26.034 11.655 26.034 26.034v78.102Z"
  />
  <path
    fill="#1767a3"
    d="M418.394 541.767h121.492v-86.78H418.394v86.78Z"
  />
  <path
    fill="#69b4ed"
    d="M539.886 465.648v-10.665H524.96l-106.566 76.123v10.657h14.926l106.566-76.115Z"
  />
  <path
    fill="#69b4ed"
    d="M418.394 454.987v10.666l106.566 76.114h14.926v-10.665L433.32 454.987h-14.926Z"
  />
</svg>
